import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";

// img
import u1 from "../../../Assets/images/authbg.png";
import { Link } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import SetCommissionPop from "../../../components/Modals/SetcommissionPop";
// import { COMMISSIONS_LIST, DELETE_COMMISSION } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import TableActions from "../../../components/Common/TableActions";
import {
  COMMISSIONS_LIST,
  DELETE_COMMISSION,
  SET_COMMISSION,
} from "../../../services/ApiCalls";
import { defaultDeleteModelState } from "../../../utilities/const";
import { catchAsync, checkResponse } from "../../../utilities/utilities";

const ManageCommssions = () => {
  const [commissionModel, setCommissionModel] = useState({
    show: false,
    dumpId: "",
    commission: "",
  });
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    refetch,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: COMMISSIONS_LIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `${key + 1}` : key + 1}</>;
      },
    },
    {
      head: "Service",
      accessor: "catName",
    },
    // { head: "Service Type", accessor: "ServiceType" },
    // { head: "Price", accessor: "Price" },
    {
      head: "Commission",
      accessor: "Commission",
      component: (item, key, arr) => (
        <>
          <p className="m-0 fw-bold">{item.commission}%</p>
        </>
      ),
    },
    {
      head: "Set New Commission",
      accessor: "SetCommission",
      component: (item, key, arr) => (
        <>
          <Button
            onClick={() =>
              setCommissionModel({
                show: true,
                dumpId: item._id,
                commission: item.commission,
              })
            }
            variant="transparent"
            size="sm"
            style={{ fontSize: 12 }}
            className="m-0 boder-0 p-0 text-success"
          >
            New Commission
          </Button>
        </>
      ),
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => {
        console.log(item, "item");
        return (
          <TableActions
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  const commissionSetHandler = catchAsync(async (data) => {
    const res = await SET_COMMISSION({ ...data, _id: commissionModel.dumpId });
    const success = checkResponse({ res, showSuccess: true });
    if (success) {
      setCommissionModel({ show: false, commission: "", dumpId: "" });
      refetch();
    }
  });

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        // setConfirmation={() => deleteModel(defaultDeleteModelState)}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() =>
            DELETE_COMMISSION({
              _id: deleteModel.dumpId,
            })
          )
        }
      />
      <SetCommissionPop
        show={commissionModel.show}
        setCommissionModel={setCommissionModel}
        hideHandle={() =>
          setCommissionModel({ show: false, dumpId: "", commission: "" })
        }
        commission={commissionModel.commission}
        submitHandler={commissionSetHandler}
      />
      <section className="manageCommissions py-4 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Manage Commissions
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                body={body}
                setBody={setBody}
                pageChangeHandler={paginationHandler}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageCommssions;
